import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", null, [
        ($props.isAutocomplete)
            ? (_openBlock(), _createBlock($setup["EnMultipleAutocompleteFilterButton"], {
                ref: "autocompleteFilterButton",
                modelValue: $setup.filters,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.filters) = $event)),
                id: $setup.filterButtonId,
                label: $setup.filterButtonLabel,
                hint: $setup.filterButtonHint,
                key: $setup.filterKey,
                "reset-filter": $setup.resetFilter,
                onFilterUpdated: $setup.updateFilters
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.filterButtonLabel), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "id", "label", "hint", "reset-filter"]))
            : (_openBlock(), _createBlock($setup["EnMultipleSearchFilterButton"], {
                ref: "notAutocompleteFilterButton",
                modelValue: $setup.filters,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.filters) = $event)),
                id: $setup.filterButtonId,
                label: $setup.filterButtonLabel,
                hint: $setup.filterButtonHint,
                "filter-type-selection-visible": $props.filterTypeSelection,
                "display-separator": $props.displaySeparator,
                "hide-menu-title": Boolean($setup.fullValueAutocompleteOptions),
                key: $setup.filterKey,
                "open-on-render": $setup.openOnRender,
                "onUpdate:openOnRender": _cache[2] || (_cache[2] = ($event) => (($setup.openOnRender) = $event)),
                onFilterUpdated: $setup.updateFilters,
                "reset-filter": $setup.resetFilter
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.filterButtonLabel), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "id", "label", "hint", "filter-type-selection-visible", "display-separator", "hide-menu-title", "open-on-render", "reset-filter"]))
    ]));
}
